import { render, staticRenderFns } from "./icon-filter.vue?vue&type=template&id=2c6ab10f&"
import script from "./icon-filter.vue?vue&type=script&lang=js&"
export * from "./icon-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports